class MeterWidget extends elementorModules.frontend.handlers.Base {
  getDefaultSettings() {
      return {
          selectors: {
              wrapper: '#meter-wrapper',
              meter: '#meter',
              background: '#background',
              low: '#low',
              med: '#med',
              high: '#high',
              needle: '#meter-needle',
              circle: '.circle'
          },
      };
  }

  getSelectors(){
      return this.getSettings( 'selectors' );
  }

  getDefaultElements() {
      const selectors = this.getSelectors();
      return {
          $wrapper: this.$element.find( selectors.wrapper ),
          $meter: this.$element.find( selectors.meter ),
          $background: this.$element.find( selectors.background ),
          $low: this.$element.find( selectors.low ),
          $med: this.$element.find( selectors.med ),
          $high: this.$element.find( selectors.high ),
          $needle: this.$element.find( selectors.needle ),
          $circles: this.$element.find( selectors.circle ),
      };
  }

  calcScore(score){
      const elems = this.getDefaultElements();
      const percent = (score/80) * 100;

      const animation = {
        transition : 'all 1s ease-in-out'
      }

      
      this.transform = {transform: `rotate(270)`}
      
      if (score <= 35){
        this.risk = 'Low'
        this.transform = {transform: `rotate(300deg)`}
      }else if (score > 35 && score < 60){
        this.risk = 'Medium'
        this.transform = {transform: `rotate(360deg)`}
      }else if(score > 59){
        this.risk = 'High'
        this.transform = {transform: `rotate(420deg)`}
      }
      
      Object.assign(animation, this.transform)
      
      
      // Add our score as a message
      jQuery('#ty-message').prepend(`
        <div id="meter-message">
          <h3>${this.risk} Risk</h3>
        </div>
      `)

      // Update needle position
      elems.$needle.css(animation)



  }

  displayMeter(score = false) {
    this.score = score;

    const radius = 200;
    const elems = this.getDefaultElements();

    const circles = elems.$circles;
    const numCircles = circles.length;

    /* Set radius for all circles */
    for (var i = 0; i < numCircles; i++) {
      circles[i].setAttribute('r', radius);
    }

    /* Set meter's wrapper dimension */
    const meterDimension = (radius * 2) + 100;

    elems.$wrapper.width(`${meterDimension}px`);
    elems.$wrapper.height(`${meterDimension}px`);
    elems.$wrapper.css('margin-bottom', `-${(meterDimension/2) - 10}px`);

    /* Add strokes to circles  */
    const cir = 2 * Math.PI * radius;
    const semiCir = cir / 2;
    const semiCirThird = semiCir / 3;
    const semiCirTwoThirds = semiCirThird * 2;

    /* Background */
    elems.$background.attr('stroke-dasharray', `${semiCir},${cir}`);
    /* Low */
    elems.$low.attr('stroke-dasharray', `${semiCir},${cir}`);
    /* Med */
    elems.$med.attr('stroke-dasharray', `${semiCirTwoThirds},${cir}`);
    /* High */
    elems.$high.attr('stroke-dasharray', `${semiCirThird},${cir}`);

    this.calcScore(this.score)

  }

  hideMeter(){
    const elems = this.getDefaultElements();
    elems.$wrapper.remove()
  }


  bindEvents(){
    const params = new URLSearchParams(window.location.search)

    if(params.has('score')){
      const score = params.get('score')

      this.displayMeter(score)
    }else{
      this.hideMeter()
    }
  }

}

jQuery( window ).on( 'elementor/frontend/init', () => {
    
    const addHandler = ( $element ) => {
        elementorFrontend.elementsHandler.addHandler( MeterWidget, {
            $element,
        } );
    };
 
    elementorFrontend.hooks.addAction( 'frontend/element_ready/prestige-widget-meter.default', addHandler );


 } );